<div class="tooltip-wrapper" #tref id="tooltip" [ngStyle]="{'top': tooltipPosTop + 'px', 'left': tooltipPosLeft + 'px'}">
    <p id="tooltip-text">{{tooltipText}}</p>
  </div>
  